import { MapDialog } from "./MapDialog";
import { html } from "lit-html";
import unsaferHTML from "@escapio/shared/unsaferHTML";
import { translate } from "../../../shared/l10n/translate";
import { store } from "../favorites/DataStore";
import { track } from "../../tracker/EventTracker";

import "./map-libre/HotelMap";

export class FavoritesMapDialog extends MapDialog {
	constructor() {
		super();
		this.titleText = translate("list_favorites_map_title");
		this.closeButtonText = translate("hotel_close_map");
		this.subtitleText = "";
		this.hotels = null;
		this.prices = {};

		store.subscribe(this.update.bind(this));
		this.update(store.getState(), store);
	}

	getTemplateContent() {
		if (!this.hotels || this.hotels.length === 0) {
			return "";
		}

		return html`
			<esc-maplibre-hotel-map
				track-name="Merkliste Karte"
				.primaryHotels=${this.hotels}
				.prices=${this.prices}
			></esc-maplibre-hotel-map>
			${this.getTransparentHeader()}
		`;
	}

	update(state) {
		if (!state.hotels) {
			return;
		}

		this.hotels = Object.values(state.hotels);
		const count = this.hotels.length;
		this.subtitleText =
			count === 1
				? unsaferHTML(
						translate(
							"list_favorites_heading_singular",
							`<strong>${count}</strong>`,
						),
					)
				: unsaferHTML(
						translate(
							"list_favorites_heading_plural",
							`<strong>${count}</strong>`,
						),
					);

		this.prices = Object.values(state.hotels).reduce(
			(acc, hotel) => ({ ...acc, [hotel.id]: hotel.state }),
			{},
		);
		this.render();
	}

	show() {
		super.show();
		track("Merkliste", "Klick Karte öffnen", this.hotels.length);
	}
}
